<template>
  <div class="class-1">
    <AppHeader title="Waiters Management" />
    <button class="add-waiter-btn" @click="navigateToAddWaiter">Add New Waiter</button>

    <table id="waiterTable">
      <thead>
        <tr>
          <th>Name</th>
          <th>Status</th>
          <th>Operations</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(waiter, index) in waiters" :key="index">
          <td>{{ waiter.name }}</td>
          <td :class="waiter.isSuspend ? 'suspended' : 'active'">
            {{ waiter.isSuspend ? 'Suspended' : 'Active' }}
          </td>
          <td class="action-buttons">
            <button data-tooltip="Edit" @click="handleEdit(waiter)">
              <img src="@/assets/edit_icon.png" alt="Edit">
            </button>
            <button 
              :data-tooltip="waiter.isSuspend ? 'Activate' : 'Suspend'" 
              @click="handleSuspend(waiter)"
            >
              <img 
                :src="waiter.isSuspend 
                 ? 
                    require('@/assets/suspend_icon.png') : 
                    require('@/assets/suspend_icon.png')"  
                :alt="waiter.isSuspend ? 'Activate' : 'Suspend'"
              >
            </button>
            <button 
              data-tooltip="Delete" 
              @click="handleDelete(waiter)"
              class="delete-btn"
            >
              <img src="@/assets/delete_icon.png" alt="Delete">
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      waiters: [],
      currentDate: "",
      currentTime: "",
    };
  },
  mounted() {
    this.updateDateTime(); 
    setInterval(this.updateDateTime, 1000); 
    this.fetchWaiters(); 
  },
  methods: {
    updateDateTime() {
      const now = new Date();
      this.currentDate = now.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      this.currentTime = now.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    async fetchWaiters() {
      try {
        this.$root.isLoading = true;
        this.loading = true;
        const token = localStorage.getItem('authToken');
        const branchId = localStorage.getItem('branchId'); 
        
        if (!branchId) {
          throw new Error('Branch ID not found in localStorage');
        }

        const response = await fetch(`${this.$BASE_API_URL}/api/waiters?branchId=${branchId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch waiters');
        }

        const { data } = await response.json();
        this.waiters = data.map(waiter => ({
          id: waiter.id,
          name: waiter.name,
          isSuspend: waiter.isSuspend,
        }));
      } catch (error) {
        console.error('Error fetching waiters:', error);
        this.$toast.error('Failed to load waiter data');
      } finally {
        this.$root.isLoading = false;
        this.loading = false;
      }
    },
    navigateToAddWaiter() {
      if (!this.$hasPermission('create waiters')){
        this.$toast.error('Not Permitted');
        return;
      }
      this.$router.push({ name: "AddWaiterComponent" });
    },
    handleEdit(waiter) {
      if (!this.$hasPermission('edit waiters')){
        this.$toast.error('Not Permitted');
        return;
      }
      this.$router.push({ 
        name: "EditWaiterComponent", 
        params: { id: waiter.id } 
      });
    },
    async handleSuspend(waiter) {
      if (!this.$hasPermission('edit waiters')) {
        this.$toast.error('Not Permitted');
        return;
      }
      
      try {
        this.$root.isLoading = true;
        this.loading = true;
        
        const token = localStorage.getItem('authToken');
        const response = await fetch(
          `${this.$BASE_API_URL}/api/waiters/${waiter.id}/toggle-status`, 
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error('Failed to toggle waiter status');
        }

        const result = await response.json();
        
        // Update local state
        waiter.isSuspend = !waiter.isSuspend;
        this.$toast.success(result.message);
      } catch (error) {
        console.error('Error toggling waiter status:', error);
        this.$toast.error(error.message || 'Failed to toggle waiter status');
      } finally {
        this.$root.isLoading = false;
        this.loading = false;
      }
    },
    async handleDelete(waiter) {
      if (!this.$hasPermission('delete waiters')){
        this.$toast.error('Not Permitted');
        return;
      }
      if (!confirm(`Are you sure you want to delete ${waiter.name}?`)) {
        return;
      }
      
      try {
        this.$root.isLoading = true; 
        this.loading = true;
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${this.$BASE_API_URL}/api/waiters/${waiter.id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to delete waiter');
        }

        this.waiters = this.waiters.filter(w => w.id !== waiter.id);
        this.$toast.success('Waiter deleted successfully');
      } catch (error) {
        console.error('Error deleting waiter:', error);
        this.$toast.error('Failed to delete waiter');
      } finally {
        this.$root.isLoading = false;
        this.loading = false;
      }
    }
  },
};
</script>
  
  <style scoped>
  .add-waiter-btn {
    float: right;
    margin-bottom: 10px;
    padding: 10px;
    background-color: #4caf50;
    color: white;
    border: none;
    cursor: pointer;
    width: max-content;
    border-radius: 5px;
    margin-top: 0.5rem;
  }
  .action-buttons {
    display: flex;
    gap: 8px;
    border-bottom: hidden;
    border-right: hidden;
  }
  .action-buttons button {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .action-buttons button:hover {
    transform: scale(1.05);
  }
  .action-buttons button:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
  }
  .action-buttons button img {
    width: 20px;
    height: 20px;
  }
  /* Status colors */
  /* .text-success {
    color: #28a745;
  }
  .text-danger {
    color: #dc3545;
  } */
  /* Delete button color */
  .delete-btn img {
    filter: invert(20%) sepia(100%) saturate(500%) hue-rotate(300deg);
  }
  </style>